import React, { Component } from 'react';

const PackBtn = ({ goToNextStep, isBottom }) => (
    <button className={`card-btn ${ isBottom ? 'isBottom' : ''}`} onClick={goToNextStep}>Choisir ce pack</button>
)

export default PackBtn;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/PackSelectorPage/Details/PackBtn.js